import styled from 'styled-components';
import { FullWidthPageContent } from 'layouts/SingleColumnLayout';

const paddingSpacingMultiplier = 2;

export default styled.div`
  > * {
    margin-bottom: ${({ theme }) => theme.spacing * 3}px;
  }

  >${FullWidthPageContent}:first-child{
    margin-top:${({ theme }) => theme.spacing * -(2 * paddingSpacingMultiplier)}px;
  }
  >${FullWidthPageContent}:last-child{
    margin-bottom:${({ theme }) => theme.spacing * -paddingSpacingMultiplier}px;
  }
`;
